<template>
  <Sidebar
    is-header
    color="basic"
    class="atb-border atb-rounded-lg"
    sidebar-opened-class="atb-w-76"
    section-class="atb-divide-y"
    header-class="atb-pt-0 atb-pr-0 atb-pl-4 atb-text-base atb-w-full atb-normal-case atb-font-medium atb-text-black"
    header-icon-class="atb-p-0 atb-flex atb-justify-center"
    body-class="abt-py-0 atb-px-4"
    :sidebar-style="{
      minHeight: 'calc(100vh - (200px))',
    }"
    :toggle-open-style="{ transform: 'translateX(240px)' }"
  >
    <template #header>
      {{ $t('search') }}
    </template>
    <template #headerIcon>
      <em class="material-icons">search</em>
    </template>
    <template #body>
      <div class="atb-grid atb-grid-rows atb-gap-3 atb-py-2">
        <div class="atb-flex atb-flex-col">
          <FormField
            :label="$t('name')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <Textbox
              id="searchPanelNameTextbox"
              v-model="searchFields.nameSearchField"
            >
            </Textbox>
          </FormField>
        </div>
        <div
          v-if="attributesPage"
          class="atb-flex atb-flex-col"
        >
          <FormField
            :label="$t('system')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <Select
              v-model="searchFields.systemSelected"
              :options="clientSytems"
            >
              <template v-slot:option="{ item }">
                {{ item.name }}
              </template>
            </Select>
          </FormField>
        </div>
        <div
          v-if="systemsPage"
          class="atb-flex atb-flex-col"
        >
          <FormField
            :label="$t('created-by')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <Select
              :placeholder="$t('allUsers')"
              v-model="searchFields.createdUserSelected"
              :options="userLoginNamesList"
            >
              <template v-slot:option="{ item }">
                {{ item.name }}
              </template>
            </Select>
          </FormField>
        </div>
        <div
          v-if="attributesPage || filtersPage"
          class="atb-flex atb-flex-col"
        >
          <FormField
            id="searchPanelLastUpdatedByDropdown"
            :label="$t('lastUpdatedBy')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <Select
              :placeholder="$t('allUsers')"
              v-model="searchFields.updatedUserSelected"
              :options="userLoginNamesList"
            >
              <template v-slot:option="{ item }">
                {{ item.name }}
              </template>
            </Select>
          </FormField>
        </div>
      </div>

      <div class="atb-grid atb-grid-cols-2 atb-gap-2 atb-py-2">
        <div class="atb-col-span-1">
          <FormField
            :label="$t('createdFrom')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <DatePicker
              v-model="searchFields.createdFromDate"
              class="eds-field atb-h-full"
            >
              <template v-slot="{ inputValue, togglePopover }">
                <div class="field-control eds-input">
                  <input
                    id="searchPanelCreatedFromTextbox"
                    :value="inputValue"
                    class="input-element"
                    readonly
                    @click="togglePopover()"
                    @keypress.enter="togglePopover()"
                  />
                  <div
                    id="searchPanelCreatedFromDateDiv"
                    class="input-append eds-input-addon atb-pl-0"
                  >
                    <span
                      class="input-addon-content input-icon"
                      @click="togglePopover()"
                    >
                      <em class="material-icons input-icon icon-color">{{
                        $t('event')
                      }}</em>
                    </span>
                  </div>
                </div>
              </template>
            </DatePicker>
          </FormField>
        </div>
        <div class="atb-col-span-1">
          <FormField
            :label="$t('to')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <DatePicker
              v-model="searchFields.createdToDate"
              class="eds-field atb-h-full"
            >
              <template v-slot="{ inputValue, togglePopover }">
                <div class="field-control eds-input">
                  <input
                    id="searchPanelCreatedToTextbox"
                    :value="inputValue"
                    class="input-element"
                    readonly
                    @click="togglePopover()"
                    @keypress.enter="togglePopover()"
                  />
                  <div
                    id="searchPanelCreatedEndDateDiv"
                    class="input-append eds-input-addon atb-pl-0"
                  >
                    <span
                      class="input-addon-content input-icon"
                      @click="togglePopover()"
                    >
                      <em class="material-icons input-icon icon-color">{{
                        $t('event')
                      }}</em>
                    </span>
                  </div>
                </div>
              </template>
            </DatePicker>
          </FormField>
        </div>
        <div class="atb-col-span-1">
          <FormField
            :label="$t('updatedFrom')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <DatePicker
              v-model="searchFields.updatedFromDate"
              class="eds-field atb-h-full"
            >
              <template v-slot="{ inputValue, togglePopover }">
                <div class="field-control eds-input">
                  <input
                    id="searchPanelUpdatedFromTextbox"
                    :value="inputValue"
                    class="input-element"
                    readonly
                    @click="togglePopover()"
                    @keypress.enter="togglePopover()"
                  />
                  <div
                    id="searchPanelUpdatedFromDateDiv"
                    class="input-append eds-input-addon atb-pl-0"
                  >
                    <span
                      class="input-addon-content input-icon"
                      @click="togglePopover()"
                    >
                      <em class="material-icons input-icon icon-color">{{
                        $t('event')
                      }}</em>
                    </span>
                  </div>
                </div>
              </template>
            </DatePicker>
          </FormField>
        </div>
        <div class="atb-col-span-1">
          <FormField
            :label="$t('to')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <DatePicker
              v-model="searchFields.updatedToDate"
              class="eds-field atb-h-full"
            >
              <template v-slot="{ inputValue, togglePopover }">
                <div class="field-control eds-input">
                  <input
                    id="searchPanelUpdatedToTextbox"
                    :value="inputValue"
                    class="input-element"
                    readonly
                    @click="togglePopover()"
                    @keypress.enter="togglePopover()"
                  />
                  <div
                    id="searchPanelUpdatedEndDateDiv"
                    class="input-append eds-input-addon atb-pl-0"
                  >
                    <span
                      class="input-addon-content input-icon"
                      @click="togglePopover()"
                    >
                      <em class="material-icons input-icon icon-color">{{
                        $t('event')
                      }}</em>
                    </span>
                  </div>
                </div>
              </template>
            </DatePicker>
          </FormField>
        </div>
      </div>

      <div class="atb-grid atb-grid-rows-2 atb-gap-3 atb-py-2">
        <div
          v-if="attributesPage || filtersPage"
          class="atb-flex atb-flex-col"
        >
          <FormField
            id="searchPanelFormatDropdown"
            :label="$t('format')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <Select
              v-model="searchFields.formatSelected"
              :options="formatOptions"
            >
              <template v-slot:option="{ item }">
                {{ item.name }}
              </template>
            </Select>
          </FormField>
        </div>
        <div
          v-if="attributesPage || filtersPage"
          class="atb-flex atb-flex-col"
        >
          <FormField
            id="searchPanelExperianProtectedDropdown"
            :label="$t('experianProtected')"
            form-field-class="atb-pb-1 atb-text-sm atb-font-medium"
          >
            <Select
              v-model="searchFields.experianSelected"
              :options="experianProtectedOptions"
            >
              <template v-slot:option="{ item }">
                {{ item.name }}
              </template>
            </Select>
          </FormField>
        </div>
      </div>
      <div class="atb-flex atb-flex-row atb-justify-end atb-gap-4 atb-pt-4">
        <Button
          id="searchPanelResetButton"
          type="submit"
          motif="tertiary"
          :title="$t('refresh')"
          @click="resetSearchForm"
        >
          <template v-slot:icon>
            <span class="material-icons"> {{ $t('sync') }} </span>
          </template>
          {{ $t('reset') }}
        </Button>
        <Button
          id="searchPanelSearchButton"
          type="submit"
          motif="primary"
          label="Search"
          :title="$t('search')"
          :styles="{ marginLeft: '10px' }"
          @click="searchClickHandler"
        />
      </div>
    </template>
  </Sidebar>
</template>

<script lang="ts" setup>
  import { computed, reactive } from 'vue';
  import Sidebar from '@atb-ui/eds-vue/src/components/Sidebar.vue';
  import Button from '@atb-ui/eds-vue/src/components/Button.vue';
  import Select from '@atb-ui/eds-vue/src/components/Select.vue';
  import { useI18n } from 'vue-i18n';
  import { useClientStore } from '@/app/features/ams/client/client-store';
  import FormField from '@atb-ui/eds-vue/src/components/Form/FormField.vue';
  import Textbox from '@atb-ui/eds-vue/src/components/Textbox.vue';
  import { useSearchStore } from '@/app/features/ams/common/search-store';

  const emit = defineEmits(['searchClicked', 'resetClicked']);

  interface SearchPanelProps {
    page: string;
  }

  const props = defineProps<SearchPanelProps>();
  const { t } = useI18n();
  const clientStore = useClientStore();
  const searchStore = useSearchStore();
  // TODO: Create an interface for this attribute or use an existing one
  const clientSytems = [] as any;

  const userLoginNamesList = searchStore.getUserLoginNamesList
    // TODO: Create an interface for this attribute or use an existing one
    .map((elem: any) => elem.login)
    // TODO: Create an interface for this attribute or use an existing one
    .map((item: any) => {
      return { name: item };
    });

  const systemsData = clientStore.getSelectedClient.systems;
  systemsData &&
    systemsData.forEach((elem) =>
      clientSytems.push({ id: elem.id, name: elem.systemName })
    );

  const formatOptions = [
    { name: t('alphanumeric'), value: 'Alphanumeric' },
    { name: t('boolean'), value: 'Boolean' },
    { name: t('date'), value: 'Date' },
    { name: t('number'), value: 'Number' },
  ];

  const experianProtectedOptions = [
    { name: t('yes'), value: 'Yes' },
    { name: t('no'), value: 'No' },
  ];

  const searchFields = reactive({
    nameSearchField: '',
    createdFromDate: null,
    createdToDate: null,
    updatedFromDate: null,
    updatedToDate: null,
    systemSelected: '',
    createdUserSelected: '',
    updatedUserSelected: '',
    formatSelected: '',
    experianSelected: '',
  });

  const attributesPage = computed(() => {
    return props.page.includes('attributes');
  });
  const systemsPage = computed(() => {
    return props.page.includes('systems');
  });
  const filtersPage = computed(() => {
    return props.page.includes('filters');
  });

  const resetSearchForm = () => {
    searchFields.nameSearchField = '';
    searchFields.systemSelected = '';
    searchFields.createdUserSelected = '';
    searchFields.updatedUserSelected = '';
    searchFields.formatSelected = '';
    searchFields.experianSelected = '';
    searchFields.createdFromDate = null;
    searchFields.createdToDate = null;
    searchFields.updatedFromDate = null;
    searchFields.updatedToDate = null;

    emit('resetClicked');
  };

  const searchClickHandler = () => {
    emit('searchClicked', searchFields);
  };
</script>
<style>
  .icon-color {
    color: #426da9;
  }
</style>
